import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Step 1: Import useNavigate
import './ServicePage.css';

const ServicePage = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Step 2: Initialize navigate

  useEffect(() => {
    axios
      .get('http://localhost:8080/pran/getallcourses')
      .then((response) => {
        setCourses(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching courses:', error);
        setError('Failed to load courses. Please try again later.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="service-section">
        <div className="service-container">
          <div className="loading-container">
            <div className="spinner"></div>
            <p className="loading-text">Loading amazing courses...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="service-section">
      <div className="service-container">
        <div className="service-header">
          <h1 className="service-title">Innovative Learning Programs</h1>
          <p className="service-subtitle">
            Empowering healthcare professionals with cutting-edge knowledge and practical skills
          </p>
        </div>

        {error && (
          <div className="error-message">
            <i className="error-icon">⚠️</i>
            <span>{error}</span>
          </div>
        )}

        <div className="courses-grid">
          {courses.length > 0 ? (
            courses.map((course, index) => (
              <div 
                className="course-card" 
                key={index}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="card-header">
                  <div className="course-icon">
                    <i className="icon">🎓</i>
                  </div>
                  <h3 className="course-title">{course.category}</h3>
                </div>
                <div className="card-body3">
                  <p className="course-description">{course.description}</p>
                </div>
                <div className="card-footer">
                  <button 
                    className="learn-more-btn"
                    onClick={() => navigate('/user-dashboard')} // Step 3: Navigate on click
                  >
                    Learn More
                    <i className="arrow">→</i>
                  </button>
                </div>
              </div>
            ))
          ) : (
            !error && (
              <div className="empty-state">
                <div className="empty-icon">📚</div>
                <h3 className="empty-title">No Courses Available</h3>
                <p className="empty-description">
                  We're preparing amazing courses for you. Check back soon!
                </p>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default ServicePage;
